export class WorkflowStepCompletionNotification {
	public viewId: number;
	public folderId: string;

	public static fromJson(other: any): WorkflowStepCompletionNotification {
		const instance = new WorkflowStepCompletionNotification();
		instance.folderId = other.FolderId;
		instance.viewId = other.ViewId;
		return instance;
	}
}
